export default __webpack_public_path__ + "static/media/plaid.5a7182e4.jpg";